import $ from 'jquery';

let support = {};
support.transition = (function() {

    let transitionEnd = (function() {

        let element = document.body || document.documentElement,
            transEndEventNames = {
                WebkitTransition : 'webkitTransitionEnd',
                MozTransition    : 'transitionend',
                OTransition      : 'oTransitionEnd otransitionend',
                transition       : 'transitionend'
            }, name;

        for (name in transEndEventNames) {
            if (element.style[name] !== undefined) return transEndEventNames[name];
        }
    }());

    return transitionEnd && { end: transitionEnd };
})();

support.animation = (function() {

    let animationEnd = (function() {

        let element = document.body || document.documentElement,
            animEndEventNames = {
                WebkitAnimation : 'webkitAnimationEnd',
                MozAnimation    : 'animationend',
                OAnimation      : 'oAnimationEnd oanimationend',
                animation       : 'animationend'
            }, name;

        for (name in animEndEventNames) {
            if (element.style[name] !== undefined) return animEndEventNames[name];
        }
    }());

    return animationEnd && { end: animationEnd };
})();

const addJqPlugin = function(name, plugin) {
    if (typeof $.fn[name] !== 'function') {
        $.fn[name] = plugin;
    }
};


/**
 *
 * @param {Function} initFunc функция инициализирующая тразишен
 * @return {Promise} promise of transition end
 */
const transitionCss = function (initFunc) {
    let _this = this;
    return new Promise(function (resolve) {
        if (support.transition) {
            _this.on(support.transition.end, function (e) {
                if (e.target !== _this[0]) {
                    return;
                }
                _this.off(support.transition.end);
                resolve();
            });
            initFunc();
        } else {
            initFunc();
            resolve();
        }
    });
};

const animateCss = function(animationName, cb, f) {
    if (!f) {
        this.off(support.animation.end).removeClass((index, className) => {
            return (className.match(/(^|\s)animate-\S+/g) || []).join(' ')
        })
    }
    this.addClass(`animated animate-${animationName}`).one(support.animation.end, () => {
        if (typeof cb === 'function') {
            cb();
        }
        $(this).removeClass(`animated animate-${animationName}`);
    });

    return this;
};

const imgLoaded = function(src) {
    return new Promise(function (resolve) {
        if (!src) {
            resolve();
            return;
        }
        let image = new Image();
        let $image = $(image);
        $image.one('load error', function() {
            //Загрузилось изображение
            resolve();
        });
        //Начинается загрузка изображения
        $image.attr("src", src);
    })

};

export {
    addJqPlugin,
    transitionCss,
    animateCss,
    imgLoaded,
}



// WEBPACK FOOTER //
// ./scripts/helper.js